import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "../../components/PageShell";
import { ExamplePageScreen } from "./ExamplePageScreen";

// The page's URL. vite.config.ts finds this file because it's in a page
// folder, and PageShell adds the flag gate and the page header.
//
// In a copied folder, leave the path below alone: on the next dev-server start
// the router rewrites it to match the new folder name.
function ExamplePageRoute() {
  return (
    <PageShell>
      <ExamplePageScreen />
    </PageShell>
  );
}

export const Route = createFileRoute("/_app/example-page")({
  component: ExamplePageRoute,
});
